import {
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_ERROR,
  SIGNUP_REQUEST,
  SIGNUP_SUCCESS,
  SIGNUP_ERROR,
  LOGOUT,
  RESTORE_AUTH_REQUEST,
} from './types';

const responseError = (error) => error && error.response
  ? { status: error.response.status, data: error.response.data }
  : null;

export const getters = {
  isAuthenticated: (state) => !!state.authToken && state.authValidated,
  isAdmin: (state) => !!state.authToken && state.authValidated && state.role === 'admin',
  authRole: (state) => state.authValidated ? state.role : null,
  operatorId: (state) => state.authValidated ? state.operatorId : null,
  authIdentity: (state) => JSON.stringify([state.authToken, state.role, state.operatorId, state.authValidated]),
  authStatus: (state) => state.authStatus,
  signupStatus: (state) => state.signupStatus,
};

export const mutations = {
  [LOGIN_REQUEST]: (state) => {
    state.authStatus.type = 'loading';
    state.authStatus.error = null;
  },
  [RESTORE_AUTH_REQUEST]: (state) => {
    state.authValidated = false;
    state.isAdmin = false;
    state.authStatus.type = 'loading';
    state.authStatus.error = null;
  },
  [LOGIN_SUCCESS]: (state, action) => {
    const profile = action.data;
    state.authStatus.type = 'success';
    state.authStatus.error = null;
    state.authToken = profile.token;
    state.role = profile.role || (profile.is_admin ? 'admin' : 'operator');
    state.isAdmin = state.role === 'admin';
    state.operatorId = state.role === 'operator' && profile.operator_id != null
      ? Number(profile.operator_id) : null;
    state.name = profile.name || '';
    state.authValidated = true;
  },
  [LOGIN_ERROR]: (state, error) => {
    state.authStatus.type = 'error';
    state.authStatus.error = responseError(error);
  },
  [SIGNUP_REQUEST]: (state) => {
    state.signupStatus.type = 'loading';
    state.signupStatus.error = null;
  },
  [SIGNUP_SUCCESS]: (state) => {
    state.signupStatus.type = 'success';
  },
  [SIGNUP_ERROR]: (state, error) => {
    state.signupStatus.type = 'error';
    state.signupStatus.error = responseError(error);
  },
  [LOGOUT]: (state) => {
    state.authToken = '';
    state.role = null;
    state.operatorId = null;
    state.name = '';
    state.isAdmin = false;
    state.authValidated = false;
    state.authStatus.type = '';
    state.authStatus.error = null;
    state.signupStatus.type = '';
    state.signupStatus.error = null;
  },
};

export const state = {
  authToken: localStorage.getItem('authToken') || '',
  role: localStorage.getItem('role') || null,
  operatorId: localStorage.getItem('operator_id') ? Number(localStorage.getItem('operator_id')) : null,
  name: '',
  isAdmin: false,
  authValidated: false,
  authStatus: { type: '', error: null },
  signupStatus: { type: '', error: null },
};
